import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { Instagram, Facebook, Twitter } from 'lucide-react';

export default function Layout({ children }) {
  return (
    <div className="relative min-h-screen">
      <Navbar />
      {/* Vertical social rail (desktop) — echoes reference image */}
      <aside
        aria-hidden="true"
        className="hidden xl:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col items-center gap-4"
      >
        <span className="text-[10px] tracking-[0.42em] text-bone-300/70 [writing-mode:vertical-rl]">FOLLOW</span>
        <span className="w-px h-12 bg-bone-100/15" />
        <a href="#" aria-label="Instagram" className="btn-ghost-icon !w-9 !h-9"><Instagram className="w-3.5 h-3.5" /></a>
        <a href="#" aria-label="Facebook" className="btn-ghost-icon !w-9 !h-9"><Facebook className="w-3.5 h-3.5" /></a>
        <a href="#" aria-label="Twitter" className="btn-ghost-icon !w-9 !h-9"><Twitter className="w-3.5 h-3.5" /></a>
      </aside>

      <main className="pt-20 lg:pt-24">{children}</main>
      <Footer />
    </div>
  );
}